import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const ErrorPage = () => import('@/views/shopify/TheShopifyErrorPage.vue')
const DoiConfirmationPage = () => import('@/views/shopify/TheShopifyDoiConfirmationPage.vue')

const routes: RouteRecordRaw[] = [
  { path: '/error', name: 'Error', component: ErrorPage },
  // Target of api-v2's Shopify DOI confirm endpoint, which redirects here with
  // ?doi=confirmed|invalid and, when the shop hands one out, &doi_voucher=<code>.
  { path: '/newsletter/confirmed', name: 'NewsletterConfirmed', component: DoiConfirmationPage },
  { path: '/:pathMatch(.*)*', redirect: { name: 'Error' } }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
